<template>
  <component
    :is="tagName"
    :style="buttonStyle"
    @mouseover="isButtonHovered = true"
    @mouseleave="isButtonHovered = false"
    @click.prevent="$emit('click')">
    {{ content }}
  </component>
</template>

<script>
export default {
  name: 'ChipButton',
  props: {
    tagName: { type: String, default: 'button' },
    content: { type: String, default: '' },
    elementStyle: { type: [Object, Boolean], default: null }
  },
  data() {
    return {
      isButtonHovered: false
    }
  },
  computed: {
    buttonStyle() {
      return {
        'background-color': this.isButtonHovered ? this.elementStyle.background : this.elementStyle.color,
        color: this.isButtonHovered ? this.elementStyle.color : this.elementStyle.background
      }
    }
  }
}
</script>
